import React from "react";
import styled from "@emotion/styled";
import planeImage from "../../../3-assets/images/misc/red-plane.png";
import puffImage from "../../../3-assets/images/misc/smoke-puff.png";

export default function AnimatedPlane() {
  return (
    <Container>
      <Plane src={planeImage} />
      <Puff src={puffImage} />
    </Container>
  );
}

const Container = styled.div``;

const Puff = styled.img`
  height: 20px;
  position: absolute;
  animation: 7s FLY linear infinite, FADE 7s infinite, SHAKE 0.2s ease infinite,
    PUFF 1s steps(1) infinite;
  @keyframes PUFF {
    0% {
      transform: translate(-20px, 30px);
    }
    50% {
      transform: translate(-30px, 28px) rotate(-45deg);
    }
    100% {
      transform: translate(-40px, 40px);
    }
  }
`;

const Plane = styled.img`
  height: 70px;
  position: absolute;
  animation: 7s FLY linear infinite, FADE 7s infinite,
    SHAKE 0.2s steps(2) infinite;

  @keyframes FLY {
    0% {
      left: calc(30vw - 40px);
    }
    35% {
      left: calc(50vw - 40px);
    }
    70% {
      left: calc(70vw - 40px);
    }
    100% {
      opacity: 0;
    }
  }

  @keyframes FADE {
    0% {
      opacity: 0;
    }
    25% {
      opacity: 1;
    }
    45% {
      opacity: 1;
    }
    70% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }

  @keyframes SHAKE {
    0% {
      top: 30vh;
    }
    33.3333% {
      top: calc(30vh + 2px);
    }
    66.6666% {
      top: 30vh;
    }
    100% {
      top: calc(30vh - 2px);
    }
  }
`;
